import React, {useRef, useState} from 'react'
import ShippingOrderPrint from "./ShippingOrderPrint";
import {Button, Modal} from "antd";
import {getShippingOrdersById, completeByPrint} from "../../../services/serviceShippingOrder";
import {useReactToPrint} from "react-to-print";

const ShippingOrderPrintContainer = ({shippingId}) => {

    const [shippingData, setShippingData] = useState();
    const [modalStatus, setModalStatus] = useState(false);

    const printRef = useRef();
    const handlePrintEvent = useReactToPrint({
        content: () => printRef.current
    });

    const handlePrintClick = () => {
        getShippingOrdersById(shippingId)
            .then(({data}) => {
                setShippingData(data);
                setModalStatus(!modalStatus);
            })
    }

    const changeModalStatus = () => setModalStatus(!modalStatus);

    const completeShipping = () => completeByPrint(shippingId);

    return(
        <React.Fragment>
            <Button
                type={"link"}
                onClick={handlePrintClick}
            >
                Yazdır
            </Button>

            <Modal
                title={'Yazdırma Ön İzleme'}
                bodyStyle={{
                    minWidth: '100%'
                }}
                style={{
                    minWidth: '85%'
                }}

                open={modalStatus}
                onCancel={changeModalStatus}
                footer={[
                    <Button
                        type={'primary'}
                        key={'SubmitButton'}
                        onClick={() => {
                            handlePrintEvent()
                            completeShipping()
                        }}
                    >
                        Yazdır
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={changeModalStatus}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <ShippingOrderPrint ref={printRef} shipping={shippingData} />
            </Modal>

        </React.Fragment>
    )
}
export default ShippingOrderPrintContainer